/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  LOAD_PRINT,
  UPDATE_PROCESS,
  ASSIGN_VENDOR,
  LOAD_VENDOR,
  LOAD_ASSIGN_HISTORY,
  UPDATE_DELIVERED,
  UPDATE_DISPATCHED,
  UPDATE_DISPATCH_HOLD

} from "./constants"

import {
  loadPrintError,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadPrintSuccess,
  loadPrint,
  updateProcessSuccess,
  updateProcessError,
  loadVendor,
  loadVendorSuccess,
  loadVendorError,
  assignVendorError,
  assignVendorSuccess,
  loadAssignHistory,
  loadAssignHistorySuccess,
  loadAssignHistoryError,
  updateDeliveredSuccess,
  updateDeliveredError,
  updateDispatchHoldSuccess,
  updateDispatchHoldError,
  updateDispatchedSuccess,
  updateDispatchedError


} from "./actions"

import {
  loadRecordsMetaData,
  loadPrintAPI,
  updateProcessAPI,
  assignVendorAPI,
  loadVendorAPI,
  assignHistoryAPI,
  updateDeliveredAPI,
  updateDispatchedAPI,
  updateDispatchHoldAPI
} from "./remotes"

function* loadPrintSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_PRINT),
    })

    const { explicitLoad } = load
    const { searchFilter } = explicitLoad || {}
    yield put(loadPrint(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPrintAPI, searchFilter)
        if (result) {
          yield put(loadPrintSuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadPrintSuccess([]))
          yield put(loadPrintError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadPrintSuccess([]))
        yield put(
          loadPrintError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadAssignHistorySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_ASSIGN_HISTORY),
    })

    const { explicitLoad } = load
    const { historyData } = explicitLoad || {}
    yield put(loadAssignHistory(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(assignHistoryAPI, historyData)
        if (result) {
          yield put(loadAssignHistorySuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadAssignHistorySuccess([]))
          yield put(loadAssignHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadAssignHistorySuccess([]))
        yield put(
          loadAssignHistoryError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {

      const employee = yield call(loadRecordsMetaData,
        "employee_dropdown_list",
        "post")
      const dispatchMode = yield call(loadRecordsMetaData, "print_deliverable_mode", "post", { status: "active" })
      const productCategory = yield call(loadRecordsMetaData, "all_deliverable_product_category", "post")
      const product = yield call(loadRecordsMetaData, "all_product", "post")
      const processStatus = yield call(loadRecordsMetaData, "all_process_status", "post")
      let permissionMetaData = {
        employeeOptions:
          (employee &&
            employee.data &&
            employee.data.length > 0 &&
            employee.data

              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.empCode.concat(" - ", c.name),
                    value: c._id,

                  }
                )
              )) ||
          [],
        productCategoryOptions:
          (productCategory &&
            productCategory.data &&
            productCategory.data.length > 0 &&
            productCategory.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.productCategory,
                    value: p._id,

                  }
                )
              )) ||
          [],
        productOptions:
          (product &&
            product.data &&
            product.data.length > 0 &&
            product.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.productName,
                    value: p._id,

                  }
                )
              )) ||
          [],

        processStatusOptions:
          (processStatus &&
            processStatus.data &&
            processStatus.data.length > 0 &&
            processStatus.data
              .filter((_) => _.status === 1)
              .map((p) =>
                Object.assign(
                  {},
                  {
                    label: p.processStatus,
                    value: p.processStatusId,
                    processStatusId: p.processStatusId,
                    colorCode: p.colorCode,
                  }
                )
              )) ||
          [],
        dispatchModeOptions:
          (dispatchMode &&
            dispatchMode.data &&
            dispatchMode.data.length > 0 &&
            dispatchMode.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.detailName,
                    value: c._id,
                    mode: c.mode
                  }
                )
              )) ||
          [],
      }

      yield put(loadRecordsMetaDataSuccess(permissionMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
          "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}


function* updateProcessSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_PROCESS),
    })
    const { submitStatus } = add || {}
    if (add) {
      try {
        yield call(updateProcessAPI, submitStatus)
        yield put(
          updateProcessSuccess(
            submitStatus,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          updateProcessError(
            (error && error.response && error.response.message) ||
            "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadVendorSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_VENDOR),
    })

    const { explicitLoad } = load
    const { searchFilter } = explicitLoad || {}
    yield put(loadVendor(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadVendorAPI, searchFilter)
        if (result) {
          yield put(loadVendorSuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadVendorSuccess([]))
          yield put(loadVendorError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadVendorSuccess([]))
        yield put(
          loadVendorError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* assignVendorSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ASSIGN_VENDOR),
    })
    const { vendor_details } = add || {}
    if (add) {
      try {
        yield call(assignVendorAPI, vendor_details)
        yield put(
          assignVendorSuccess(
            vendor_details,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          assignVendorError(
            (error && error.response && error.response.message) ||
            "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
//
function* updateDispatchedSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_DISPATCHED),
    })
    const { updateStatus } = add || {}
    if (add) {
      try {
        yield call(updateDispatchedAPI, updateStatus)
        yield put(
          updateDispatchedSuccess(
            updateStatus,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          updateDispatchedError(
            (error && error.response && error.response.message) ||
            "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* updateDeliveredSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_DELIVERED),
    })
    const { updateStatus } = add || {}
    if (add) {
      try {
        yield call(updateDeliveredAPI, updateStatus)
        yield put(
          updateDeliveredSuccess(
            updateStatus,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          updateDeliveredError(
            (error && error.response && error.response.message) ||
            "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
function* updateDispatchHoldSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_DISPATCH_HOLD),
    })
    const { updateStatus } = add || {}
    if (add) {
      try {
        yield call(updateDispatchHoldAPI, updateStatus)
        yield put(
          updateDispatchHoldSuccess(
            updateStatus,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          updateDispatchHoldError(
            (error && error.response && error.response.message) ||
            "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadPrintSaga(),

    loadRecordsMetaDataSaga(),

    updateProcessSaga(),

    assignVendorSaga(),

    loadVendorSaga(),

    loadAssignHistorySaga(),

    updateDeliveredSaga(),

    updateDispatchHoldSaga(),

    updateDispatchedSaga()
  ])
}
